import { render, staticRenderFns } from "./SSOUserVerify.vue?vue&type=template&id=fdd0c7bc&scoped=true"
import script from "./SSOUserVerify.vue?vue&type=script&lang=js"
export * from "./SSOUserVerify.vue?vue&type=script&lang=js"
import style0 from "./SSOUserVerify.vue?vue&type=style&index=0&id=fdd0c7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd0c7bc",
  null
  
)

export default component.exports